<!--
  - Author: Raul Perusquia <raul@inikoo.com>
  - Created: Tue, 20 Feb 2024 07:54:36 Central Standard Time, Mexico City, Mexico
  - Copyright (c) 2024, Raul A Perusquia Flores
  -->

<script setup lang="ts">
import { Link, router } from "@inertiajs/vue3";
import { reactive, inject } from "vue";
import MenuPopoverList from "@/Layouts/Grp/MenuPopoverList.vue";
import TopBarSelectButton from "@/Layouts/Grp/TopBarSelectButton.vue";
import { Menu, MenuItems, MenuItem } from "@headlessui/vue";
import { Disclosure } from "@headlessui/vue";
import Button from "@/Components/Utils/Button.vue";
import { trans } from "laravel-vue-i18n";
import Image from "@/Components/Utils/Image.vue";
import { usePage } from "@inertiajs/vue3";
import { faChevronDown } from "@far";
import { } from "@fal";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import MenuTopRight from "@/Layouts/Grp/MenuTopRight.vue";
import TopBarDropdownScope from "@/Layouts/Grp/TopBarDropdownScope.vue";
import { layoutStructure } from "@/Composables/useLayoutStructure";
import { faBallot } from "@fas";
import ScreenWarning from "@/Components/Utils/ScreenWarning.vue";

library.add();

defineProps<{
    sidebarOpen: boolean
    logoRoute: string
    urlPrefix: string
}>();

defineEmits<{
    (e: "sidebarOpen", value: boolean): void
}>();

// To handle skeleton image in dropdown
const imageSkeleton: { [key: string]: boolean } = reactive({});

const layoutStore = inject("layout", layoutStructure);


</script>

<template>
    <nav class="fixed top-0 z-[24] pb-2 md:pb-0  w-full bg-gray-50 xtext-gray-700">

        <div class="px-0">
            <div class="flex h-11 lg:h-10">
                <div class="flex">
                    <!-- Mobile: Hamburger -->
                    <!-- <button class="block md:hidden w-10 h-10 relative focus:outline-none"
                        @click="$emit('sidebarOpen', !sidebarOpen)">
                        <span class="sr-only">Open sidebar</span>
                        <div class="block w-5 absolute left-1/2 top-1/2   transform  -translate-x-1/2 -translate-y-1/2">
                            <span aria-hidden="true"
                                class="block absolute rounded-full h-0.5 w-5 bg-gray-900 transform transition duration-200 ease-in-out"
                                :class="{ 'rotate-45': sidebarOpen, ' -translate-y-1.5': !sidebarOpen }"></span>
                            <span aria-hidden="true"
                                class="block absolute rounded-full h-0.5 w-5 bg-gray-900 transform transition duration-100 ease-in-out"
                                :class="{ 'opacity-0': sidebarOpen }"></span>
                            <span aria-hidden="true"
                                class="block absolute rounded-full h-0.5 w-5 bg-gray-900 transform transition duration-200 ease-in-out"
                                :class="{ '-rotate-45': sidebarOpen, ' translate-y-1.5': !sidebarOpen }"></span>
                        </div>
                    </button> -->

                    <!-- App Title: Image and Title -->
                    <div vxif="false"
                        class="overflow-hidden relative flex flex-1 items-center xmb-2 pt-3"
                        xclass="[layout.leftSidebar.show ? 'md:w-48 md:pr-4' : 'md:w-12']"
                    >
                        <Link
                            :href="route('home')"
                            class="flex flex-nowrap items-center h-full gap-x-1.5"
                            xclass="[layout.leftSidebar.show ? 'py-1 pl-4' : 'pl-2.5 w-full']">
                            
                            <div class="inline-flex items-center justify-center w-auto rounded-sm">
                                <img src="/logo-kr-transparent.webp" alt="Repro App Logo" class="h-6 object-contain" />
                            </div>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    </nav>
</template>
